import React from "react";
import "./Button.css";

/**
 *
 * @param {function} onClick the function to be called when the button is clicked
 * @param {boolean} disabled determine if the button is disbled or not
 * @param {string} text text of the button
 * @param {boolean} hidden determine if the button should be shown or not
 * @param {string} btnStyle the style of the button, can be 'primary' or 'secondary'
 * @returns
 */
function Button({ onClick, disabled, text, btnStyle = "primary" }) {

  function getClassName(style) {
    switch (style) {
      case "alt1":
        return "button alt1";
      case "primary":
      default:
        return "button";
    }
  }

  return (
    <div className="buttonWrapper">
      <button className={getClassName(btnStyle)} disabled={disabled} onClick={onClick}>
        {text}
      </button>
    </div>
  );
}

export default React.memo(Button);
